import { useState, useEffect } from 'react'
import { Table, TableBody, TableHead, TableRow, TableCell, Paper, Button, Grid, Checkbox, IconButton } from "@material-ui/core";
import { globalGetService, globalDeleteService } from '../../../utils/globalApiServices';
import { useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { TemplateCRU, TemplatesList } from '../components';
import { checkApiStatus, } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { permissionCheckFnforCamo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import FilterComponent from '../../../shared_elements/components/filter_component';
import { template_Filter } from '../components';
import Pagination from '../../../shared_elements/components/Pagination';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
const TemplatesHeaders = ({ toggleBulkOps, bulk, data,setBulk }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <Checkbox
                        color="primary"
                        size="small"
                        onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', data)}
                        checked={data?.length === bulk?.ids?.length && data?.length > 0}
                    />
                     {bulk?.type && bulk?.ids?.length ? <IconButton className="delete-icon">
                        <DeleteOutlinedIcon color='secondary' onClick={() => setBulk({ ...bulk, title: 'Delete', modal: true })} />({bulk?.ids?.length})
                    </IconButton> : null}
                </TableCell>
                <TableCell style={{ minWidth: "120px" }}> Action(s) </TableCell>
                <TableCell style={{ minWidth: "120px" }}> Engine Family  </TableCell>
                <TableCell style={{ minWidth: "170px" }}> Remarks </TableCell>
                <TableCell style={{ minWidth: "100px" }}> Section </TableCell>
                <TableCell style={{ minWidth: "190px" }}> Attachment </TableCell>
                <TableCell style={{ minWidth: "80px" }}> Active </TableCell>
                <TableCell style={{ minWidth: "100px" }}> Created By </TableCell>
                <TableCell style={{ minWidth: "100px" }}> Modified By </TableCell>
            </TableRow>
        </TableHead>
    )
}

function Templates({ match }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [skeltonLoader, setSkeltonLoader] = useState(false)
    const [filter, setFilter] = useState({});
    const [templateList, setTemplateList] = useState({ modal: false, data: null })
    const [data, setData] = useState({ list: [], pagination: {} })
    const [templatesCRU, setTemplatesCRU] = useState({ modal: false, data: null, type: '' })
    const [egineFamily, setEngineFamily] = useState([])
    const [userList, setUserList] = useState({ createdBy: [], updatedBy: [] })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })

    useEffect(() => {
        getTemplatesList({ per_page: 20 }, 'skeltonLoader')
        getEngineFamily()
        getUserList()
        trackActivity('Airworthiness Management', {
            event_type: 'Templates Section Page Visited',
            page_title: 'Templates Section'
        });
    }, [])

    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }
    const getUserList = () => {
        globalGetService(`camo/template/userlist/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setUserList({ createdBy: response?.data?.created_by_list, updatedBy: response?.data?.updated_by_list })
                }
            })
    }
    const getTemplatesList = (query, loaderType) => {
        loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true)
        globalGetService(`camo/template/sample/`, query)
            .then((response) => {
                loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                if (checkApiStatus) {
                    setData(response?.data?.data)
                    delete query?.page
                    delete query?.per_page
                    setFilter(query)
                } else {
                    loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
                }
            })
    }

    const deleteTemplatesList = () => {
        setLoading(true)
        globalDeleteService(!bulk?.ids?.length ? `camo/template/sample/${templateList?.data?.id}/` : `camo/template/bulk_delete/`, { delete_ids: bulk?.ids.map(item => item?.id) })
            .then((response) => {
                setLoading(false); setTemplateList({ modal: false }); getTemplatesList({ per_page: 20 })
                setBulk({ modal: false, ids: [], title: '', type: '' })
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Airworthiness Management', {
                        event_type: 'Templates Delete',
                        page_title: 'Templates Deleted Success',
                        deleted_id: templateList?.data?.id,
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Airworthiness Management', {
                        event_type: 'Templates  Delete ',
                        page_title: 'Templates Delete Failed ',
                        deleted_id: templateList?.data?.id,
                        error_msg: response?.data?.message
                    })
                }

            })
    }
    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem?.id !== item.id) })
        }
    }

    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    let filterOptions = template_Filter
    filterOptions = {
        ...filterOptions,
        engine_family: {
            ...filterOptions.engine_family,
            options: egineFamily,
        },
        created_by: {
            ...filterOptions.created_by,
            options: userList?.createdBy || [],
        },
        updated_by: {
            ...filterOptions.updated_by,
            options: userList?.updatedBy || [],
        },
    }
    const onDeleteTempFileRes = (item) => {
        if (templatesCRU?.data?.id && templatesCRU?.modal) {
            setTemplatesCRU({
                ...templatesCRU,
                data: {
                    ...templatesCRU.data,
                    file_path: templatesCRU?.data?.file_path === item?.file_path && null,
                    file_name: templatesCRU?.data?.file_name === item?.file_name && null
                }
            })
        }
    }
    return (
        <>
            <section className='camo-template-module'>
                {skeltonLoader ? <STableLoader count={7} /> : <>
                    <Paper square variant='outlined'>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={9}>
                                <div style={{ marginTop: "2px" }}>
                                    <FilterComponent
                                        filter={filterObj}
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getTemplatesList({ ...applyFilter, page: 1, per_page: templateList?.pagination?.per_page || 20 }, 'pageLoader')}
                                    />
                                </div>
                            </Grid>
                            <Grid item md={3}>
                                {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) ?
                                    <ul style={{ padding: "8px", float: "right", }} className="list-inline"  >
                                        {/* {bulk?.type && bulk?.ids?.length ? <> <li className="list-inline-item" style={{ cursor: 'pointer' }} onClick={() => setBulk({ modal: false, ids: [], title: '', type: '' })}>
                                            <Tooltip title='Cancel' arrow><CloseIcon color='primary' /></Tooltip>
                                        </li>
                                            <li className="list-inline-item" style={{ cursor: 'pointer', marginInline: "5px" }}>
                                                <Button onClick={() => setBulk({ ...bulk, title: 'Delete', modal: true })} size="small" variant="outlined" color="secondary">Delete ({bulk?.ids?.length})</Button>
                                            </li></> : null} */}
                                        <li className='list-inline-item' >
                                            <Button variant='contained' color='primary' size='small' onClick={() => setTemplatesCRU({ modal: true, data: null, type: 'add' })}>Add Template</Button>
                                        </li>
                                    </ul>
                                    : null}
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper variant='outlined' square style={{ marginBottom: "5px" }}>
                        <div style={{ height: `${window.innerHeight - 195}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader={true}>
                                <TemplatesHeaders toggleBulkOps={toggleBulkOps} bulk={bulk} data={data?.list}  setBulk={setBulk}/>
                                <TableBody>
                                    {data?.list?.length > 0 && data?.list?.map((item, index) =>
                                        <TemplatesList
                                            item={item}
                                            key={index}
                                            toggleBulkOps={toggleBulkOps}
                                            bulk={bulk}
                                            onEditFn={() => setTemplatesCRU({ modal: true, data: item, type: 'edit' })}
                                            onDeleteFn={() => setTemplateList({ modal: true, data: item })}
                                            onViewFn={() => setTemplatesCRU({ modal: true, type: 'view', data: item })}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                            {!data?.list?.length ? <EmptyCollection title="No Records Founds" /> : null}
                        </div>
                        <Pagination
                            pagination={data?.pagination}
                            onChangePage={(event, newPage) => getTemplatesList({ ...filter, page: newPage + 1, per_page: data?.pagination?.per_page || 20 }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getTemplatesList({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>
                </>}
                {templatesCRU?.modal ?
                    <TemplateCRU
                        tempData={templatesCRU?.data}
                        modeType={templatesCRU?.type}
                        getTempDelFileRes={(id)=>onDeleteTempFileRes(id)}
                        modalCloseFn={() => setTemplatesCRU({ modal: false, data: null, type: "" })}
                        getResponseBack={() => getTemplatesList({ per_page: data?.pagination?.per_page || 20 }, 'pageLoader')}
                    /> : null
                }
                {templateList.modal || bulk.modal ?
                    <DeletePopUp
                        title='Delete Template'
                        deleteRecordFn={() => deleteTemplatesList()}
                        modal={true}
                        content={`Do you really want to delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record`}
                        toggleModalFn={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : setTemplateList({ modal: false })}
                    /> : null

                }
                {isLoading ? <PageLoader /> : null}
            </section>
        </>
    )
}

export default withRouter(Templates)